import { createApp, h, reactive } from 'vue'
import vuetify from './plugins/vuetify'
import LmsNoticeDialog from './components/LmsNoticeDialog.vue'

const state = reactive({
  open: false,
  title: 'Notice',
  message: '',
  tone: 'success',
  confirmLabel: 'OK',
  resolve: null
})

function closeAndResolve () {
  state.open = false
  const resolve = state.resolve
  state.resolve = null
  if (typeof resolve === 'function') resolve()
}

function show (options = {}) {
  state.title = options.title || 'Notice'
  state.message = options.message || ''
  state.tone = options.tone || 'success'
  state.confirmLabel = options.confirmLabel || 'OK'
  state.open = true

  return new Promise((resolve) => {
    state.resolve = resolve
  })
}

export function installLmsNotice () {
  if (typeof window === 'undefined') return
  if (window.LmsNotice?.show) return

  let host = document.getElementById('lms-notice-host')
  if (!host) {
    host = document.createElement('div')
    host.id = 'lms-notice-host'
    document.body.appendChild(host)
  }

  createApp({
    setup () {
      return () => h(LmsNoticeDialog, {
        modelValue: state.open,
        title: state.title,
        message: state.message,
        tone: state.tone,
        confirmLabel: state.confirmLabel,
        'onUpdate:modelValue': (value) => {
          if (!value) closeAndResolve()
          else state.open = true
        },
        onConfirm: closeAndResolve
      })
    }
  }).use(vuetify).mount(host)

  window.LmsNotice = { show }
}
